import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrustPilotIcon } from './Icons';
import { Proposition } from './Proposition';

export const TrustPilotProposition = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <Proposition message={t('fundraising.proposition.message.ratedExcellent')}>
      <TrustPilotIcon />
    </Proposition>
  );
};
